import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    gap: 24,
  },
  logoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoImage: {
    width: 67.2,
    height: 32,
    alignContent: 'center',
    justifyContent: 'center',
  },
  emailContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: themes.light.gray_blue[6],
    padding: 16,
    flexWrap: 'wrap',
    maxWidth: '100%',
    borderRadius: 12,
  },
  emailText: {
    flexShrink: 1,
    flexWrap: 'wrap',
    textAlign: 'center',
    maxWidth: '90%',
    overflow: 'hidden',
  },
  profileImage: {
    width: 32,
    height: 32,
    marginRight: 16,
    alignContent: 'center',
    justifyContent: 'center',
  },
  topText: {
    textAlign: 'center',
  },
  bottomText: {
    textAlign: 'center',
  },
  link: {
    color: themes.light.brand_blue[3],
  },
  button: {
    paddingBottom: 24,
  },
});
